(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .component('vmHardwareVirtualDisk', {
            templateUrl: 'vm-ui/resources/vm/views/settings/vmHardwareSettings/vmHardwareVirtualDisk/vmHardwareVirtualDisk.html',
            controller: VmHardwareVirtualDiskController,
            controllerAs: 'ctrl',
            bindings: {
               inflatedDevice: '<',
               selectedStorageProfile: '<',
               selectedDiskFormat: '<',
               storageBaselineId: '<',
               getAdvancedConfigurationForDisk: '&',
               getStorageForDisk: '&',
               storageProfiles: '<',
               isVmEncrypted: '<',
               createMode: '<',
               cloneMode: '<',
               deployVmtxMode: '<',
               virtualMachineDevices: '<',
               setStorageForDisk: '&',
               vmConfigContext: '<',
               vmStorageId: '@',
               vmAssignmentsProperties: '<',
               computeResourceId: '<',
               vmHomeReplicationGroup: '<',
               storageLocatorItemsData: '<',
               removeCallback: '&',
               vmId: '<',
               showStoragePods: '<',
               expanded: '=',
               keepExistingProfileAssignments: '<',
               isGroupingHardDisks: '<'
            }
         });

   VmHardwareVirtualDiskController.$inject = [
      '$q',
      '$scope',
      '$rootScope',
      '$element',
      'i18nService',
      'virtualDiskSettingsFormService',
      'diskProvisioningService',
      'vmDatastoreLocationBrowserService',
      'defaultUriSchemeUtil',
      'datastoreService',
      'authorizationService',
      'VirtualDisk',
      'vmHardwareVirtualDiskService',
      'vmDeviceInfoService',
      'managedEntityConstants',
      'deviceClassLineageService',
      '$timeout',
      'diskBackingInfoConstants',
      'storageProfileService',
      'spbmReplicationGroupInfoService',
      'deviceTypeConstants',
      'virtualDiskPmemService',
      'vmCryptUtilService',
      'basicDiskUtilService'
   ];

   function VmHardwareVirtualDiskController(
         $q,
         $scope,
         $rootScope,
         $element,
         i18nService,
         virtualDiskSettingsFormService,
         diskProvisioningService,
         vmDatastoreLocationBrowserService,
         defaultUriSchemeUtil,
         datastoreService,
         authorizationService,
         VirtualDisk,
         vmHardwareVirtualDiskService,
         vmDeviceInfoService,
         managedEntityConstants,
         deviceClassLineageService,
         $timeout,
         diskBackingInfoConstants,
         storageProfileService,
         spbmReplicationGroupInfoService,
         deviceTypeConstants,
         virtualDiskPmemService,
         vmCryptUtilService,
         basicDiskUtilService
   ) {

      var DELETE_FILE_FROM_DISK_OPERATION = 'destroy';

      var browseDialogOption, selectedStorage, buildStorageSelectConfig,
            checkDiskLocationPrivilege, storeWithVmOption, setDiskLocationValidity;
      var self = this;

      var device = self.inflatedDevice.getCurrentDevice();

      var datastoreInfo = datastoreService.findDatastore(
         self.vmStorageId,
         self.vmConfigContext.environment.configTarget);
      self.isPoweredOn = self.vmConfigContext.environment.powerState === 'poweredOn';
      self.deviceName = device.deviceInfo.label;
      self.formKey = self.inflatedDevice.getKey().toString().replace('-', '__');
      self.i18n = i18nService.getString;
      self.controllerSelectorName = 'editVirtualDeviceController' + self.formKey;
      self.controllerNodeSelectorName = 'editVirtualDeviceNode' + self.formKey;
      self.deleteFilesFromDisk = false;
      if (self.inflatedDevice.getDiskFileOperation() === DELETE_FILE_FROM_DISK_OPERATION) {
         self.deleteFilesFromDisk = true;
      }
      self.formId = 'vmHardwareVirtualDiskForm' + self.formKey;
      self.diskLocationErrorConfig = {
         message: self.i18n('VmUi',
               'SelectDatastoreProvisioningPage.NoPermissionOnDatastore'),
         isVisible: false
      };

      self.diskProfileErrorConfig = {
         message: undefined,
         isVisible: false
      };
      self.isPmemDisk = self.inflatedDevice.isPmemDisk();
      self.isExistingPmemDisk =
            self.inflatedDevice.isPmemDisk() && !self.inflatedDevice.isNew();

      self.isVmHomeProfileChanged = false;
      self.isDiskAlreadyEncrypted = self.inflatedDevice.isDiskAlreadyEncrypted();
      self.isStorageProfileChanged = false;
      self.isEncryptionProfileApplied = self.inflatedDevice.isEncryptionProfileApplied();

      $scope.$watch(function() {
         return self.vmConfigContext.vmProfile;
      }, _.bind(function(newValue, oldValue) {
         if (newValue !== oldValue) {
            self.isVmHomeProfileChanged = true;
            self.checkEncryptionWarning();
         }
      }, self));

      $scope.$watch(function() {
         return self.inflatedDevice.storageProfile;
      }, _.bind(function(newValue, oldValue) {
         if (newValue !== oldValue) {
            self.updateProfile(newValue, null, false);
            if (self.virtualDiskSettingsForm.storageProfile) {
               self.virtualDiskSettingsForm.storageProfile.selection = newValue;
            }
         }
      }, self));

      self.onUnitChanged = function(newUnit) {
         self.virtualDiskSettingsForm.capacity.memoryUnitPreferred = newUnit;
         self.inflatedDevice.getCurrentDeviceSpec().memoryUnitPreferred = newUnit;
      };

      self.onValueChanged = function() {
         self.inflatedDevice.updateCapacity(
               self.virtualDiskSettingsForm.capacity.valueInMB);

         $rootScope.$broadcast(vmHardwareVirtualDiskService.DISK_SIZE_UPDATED, {
            size: self.virtualDiskSettingsForm.capacity.valueInMB,
            units: self.virtualDiskSettingsForm.capacity.memoryUnitPreferred.label
         });
      };

      self.isExpandable = function() {
         if (self.deployVmtxMode) {
            return false;
         }
         if (!self.virtualDiskSettingsForm) {
            return false;
         } else {
            return true;
         }
      };

      self.updateProfileFromUi = function(selectedStorageProfile) {
         self.updateProfile(selectedStorageProfile);
         self.inflatedDevice.setStorageProfileManuallySet(true);
         updateReplicationGroupData(selectedStorageProfile);
      };

      self.updateProfile = function(selectedStorageProfile, replicationGroupInfo, broadcastEvent) {
         self.isStorageProfileChanged = true;
         replicationGroupInfo = replicationGroupInfo ||
            (self.selectedReplicationGroupItem
               ? self.selectedReplicationGroupItem.replicationGroupInfo
               : null);

         self.inflatedDevice.updateDiskProfile(selectedStorageProfile, replicationGroupInfo);

         self.isPmemDisk = virtualDiskPmemService.handlePmemIfPmemProfile(
               self.inflatedDevice, selectedStorageProfile, self.selectedDiskFormat);
         self.isEncryptionProfileApplied = self.inflatedDevice.isEncryptionProfileApplied();
         if (!self.isEncryptionProfileApplied) {
            self.inflatedDevice.getCurrentDevice().backing.keyId = null;
         }

         self.checkEncryptionWarning();

         if (broadcastEvent !== false) {
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISKS_UPDATED);
         }
      };

      self.checkEncryptionWarning = function() {
         // VM Home must be encrypted in order to encrypt disks
         if (self.isEncryptionProfileApplied && !self.isVmHomeEncrypted()) {
            self.setDiskProfileValidity(false,
               self.i18n('VmUi', 'DiskConfig.ErrorVmHomeEncryptionRequired'));
            return;
         }

         // Can't encrypt while adding existing disk
         if (self.inflatedDevice.isCreatedFromExistingDisk()
            && self.isEncryptionProfileApplied && !self.isDiskAlreadyEncrypted) {
            self.setDiskProfileValidity(false,
               self.i18n('VmUi', 'DiskConfig.ErrorNoEncryptionOnAttach'));
            return;
         }

         // Can't decrypt while adding existing disk
         if (self.inflatedDevice.isCreatedFromExistingDisk()
               && !self.isEncryptionProfileApplied && self.isDiskAlreadyEncrypted) {
            self.setDiskProfileValidity(false,
                  self.i18n('VmUi', 'DiskConfig.ErrorNoDecryptionOnAttach'));
            return;
         }

         self.setDiskProfileValidity(true);
      };

      self.isVmHomeEncrypted = function() {
         // Check if the VM Home profile is encryption one
         if (self.vmConfigContext.vmProfile) {
            var vmHomeProfile = storageProfileService.findProfile(
                  self.storageProfiles, self.vmConfigContext.vmProfile[0]);
            self.isVmEncrypted = storageProfileService
                  .isEncryptionStorageProfile(vmHomeProfile);
            return self.isVmEncrypted;
         }

         // If the VM profile is not changed and VM Home is encrypted - return TRUE.
         // The key will be empty when in provisioning mode,
         // so only return if there is a key.
         if (!self.isVmHomeProfileChanged &&
            !vmCryptUtilService.isCryptoKeyEmpty(self.vmConfigContext.config.keyId)) {
            self.isVmEncrypted = true;
            return self.isVmEncrypted;
         }

         return self.isVmEncrypted;
      };

      self.getDiskEncryptionStatus = function() {
         return vmCryptUtilService.getDiskEncryptionStatus(self.isDiskAlreadyEncrypted,
            self.isStorageProfileChanged, self.isEncryptionProfileApplied);
      };

      self.setDiskProfileValidity = function(isValid, errorMessage) {
         self.diskProfileErrorConfig.isVisible = !isValid;
         self.diskProfileErrorConfig.message = errorMessage;

         var form = self[self.formId];
         if (form) {
            var diskProfileElem = form['storage-profile'];
            if (diskProfileElem) {
               diskProfileElem.$invalid = !isValid;
            }
            self[self.formId].$setValidity('diskProfile', isValid);
         }
      };

      self.updateDiskProvisioningType = function(selectedProvisionOptionType) {
         var backingType = diskProvisioningService.backingInfoKeys(selectedProvisionOptionType);
         self.inflatedDevice.updateDiskProvisioningOption(backingType);
      };

      self.updateDiskController = function(selectedController, selectedControllerNode) {
         if (selectedControllerNode) {
            self.inflatedDevice.updateControllerAndNodeKeys(selectedController.getKey(), selectedControllerNode.key);
         }
      };

      /** We want to show the disk file in the following cases:
       * - when we edit an existing disk
       * - when we add a disk from an existing one
       * We don't want to show it when:
       * - creating a new disk
       * - cloning an existing disk
       */
      self.showDiskFile = function() {
         return self.expanded &&
            ((!self.createMode && !self.cloneMode)
               || self.inflatedDevice.isCreatedFromExistingDisk())
            && !!self.virtualDiskSettingsForm && !!self.virtualDiskSettingsForm.diskFile;
      };

      self.isRemoveDisabled = function() {
         if(!self.createMode) {
            return vmHardwareVirtualDiskService.isRemoveDiskDisabled(self.vmConfigContext.privileges);
         }

         return false;
      };

      self.onRemoveHardDisk = function() {
         if(!self.isRemoveDisabled() && self.removeCallback){
            self.removeCallback()(self.inflatedDevice);
            if (self.isPmemDisk) {
               self.deleteFilesFromDisk = true;
               self.updateDiskFileOperation();
            }
         }
      };

      self.isEditIopsLimitDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditIopsLimitDisabled(
               self.vmConfigContext.privileges, self.createMode);
      };

      self.getPmemMax = function() {
         return virtualDiskPmemService.getMaxAllowedCapacity(
               self.vmConfigContext, self.inflatedDevice, self.virtualMachineDevices);
      };

      self.getDiskText = function() {
         if (!self.virtualDiskSettingsForm) {
            return '';
         }
         var diskSize = basicDiskUtilService.determineDisplayDiskSize(
               self.virtualDiskSettingsForm.capacity.valueInMB);
         return diskSize ?
               (basicDiskUtilService.roundToPrecision(diskSize.size, 2).toString() + ' ' + diskSize.unitText ) :
               '';
      };

      self.shouldShowDiskSizeLabelOnly = function() {
         if (!self.virtualDiskSettingsForm) {
            return true;
         }

         return !self.inflatedDevice.isNew() && self.isGroupingHardDisks &&
               (!self.virtualDiskSettingsForm.capacity.validUnits ||
               !self.expanded);
      };

      self.getMax = function() {
         if(isExistingDiskAddition()) {
            //To Skip validation errors on a disabled field
            return Number.MAX_VALUE;
         } else {
            if (self.isPmemDisk) {
               return self.getPmemMax();
            }
            return self.virtualDiskSettingsForm.capacity.maxInMB;
         }
      };

      self.getMin = function() {
         if(isExistingDiskAddition()) {
            //To Skip validation errors on a disabled field
            return Number.MIN_VALUE;
         } else {
            if (!self.isDiskEditable) {
               return Number.MIN_VALUE;
            }
            if (self.isExistingPmemDisk) {
               return self.inflatedDevice.getOriginalCapacityInMB();
            }
            if (self.isPmemDisk) {
               return virtualDiskPmemService.getDefaultMinValueForNewPmemDisk();
            }
            return self.virtualDiskSettingsForm.capacity.minInMB;
         }
      };

      var formId = 'vmHardwareVirtualDiskForm' + self.formKey;

      self.replicationGroupItems = [];
      self.selectedReplicationGroupItem = null;

      self.replicationGroupErrorConfig = {
         message: "",
         isVisible: false
      };

      var validateReplicationGroupSelection = function() {

         function getReplicationGroupError() {

            if (!self.replicationGroupItems || !self.replicationGroupItems.length) {
               return "";
            }

            if (!self.selectedReplicationGroupItem) {
               return self.i18n("VmUi", "DiskConfig.selectReplicationGroup");
            }

            var rgAssignments = [];
            if (self.vmHomeReplicationGroup) {
               rgAssignments.push(self.vmHomeReplicationGroup);
            }
            _.forEach(self.virtualMachineDevices.devicesNotMarkedForRemovalOfType("VirtualDisk"), function(virtualDisk) {
               var diskRg = null;
               if (self.cloneMode) {
                  var advancedConfiguration =
                        self.getAdvancedConfigurationForDisk({virtualDiskDevice: virtualDisk});
                  if (advancedConfiguration) {
                     diskRg = advancedConfiguration.replicationGroup;
                  } else {
                     diskRg = virtualDisk.getCurrentReplicationGroup();
                  }
               } else {
                  diskRg = virtualDisk.getCurrentReplicationGroup();
               }
               if (diskRg) {
                  rgAssignments.push(diskRg);
               }
            });

            return spbmReplicationGroupInfoService
               .validateVmReplicationGroupAssignments(rgAssignments);
         }

         self.replicationGroupErrorConfig.message = getReplicationGroupError();
         var isValid = !self.replicationGroupErrorConfig.message;
         self.replicationGroupErrorConfig.isVisible = !isValid;

         var form = self[formId];
         if (form) {
            var replicationGroupElem = form['replication-group'];
            if (replicationGroupElem) {
               replicationGroupElem.$invalid = !isValid;
            }
            self[formId].$setValidity('replicationGroup', isValid);
         }
      };

      self.virtualMachineDevices.addRgValidationCallback(
            device.key, validateReplicationGroupSelection);

      var updateReplicationGroupData = function(selectedProfile, selectedStorageRef) {

         if ((self.cloneMode && !self.inflatedDevice.isNew())) {
            return;
         }

         if (!selectedProfile && self.virtualDiskSettingsForm.storageProfile) {
            selectedProfile = self.virtualDiskSettingsForm.storageProfile.selection;
         }

         if (!selectedStorageRef) {
            var currentSpec = self.inflatedDevice.getCurrentDeviceSpec();

            if (currentSpec && currentSpec.device && currentSpec.device.backing &&
                  currentSpec.device.backing.datastore) {
               selectedStorageRef = currentSpec.device.backing.datastore;
            } else if (self.vmStorageId) {
               selectedStorageRef = defaultUriSchemeUtil.getManagedObjectReference(
                     self.vmStorageId);
            }
         }

         storageProfileService.requestCompatibilityResultForDatastore(
               selectedProfile && selectedProfile.profileObj,
               selectedStorageRef).then( function(result) {

            self.replicationGroupItems = [];
            self.selectedReplicationGroupItem = null;

            var currentRgId = self.inflatedDevice.getCurrentReplicationGroup() ?
                  self.inflatedDevice.getCurrentReplicationGroup().id: null;

            var triggerRgUpdate = !!currentRgId;

            if (result && result.compatibilityResult) {

               var computeResourceRef = self.computeResourceId
                     ? defaultUriSchemeUtil.getManagedObjectReference(self.computeResourceId)
                     : null;
               var hostRefs = (computeResourceRef && computeResourceRef.type === "HostSystem")
                     ? [computeResourceRef]
                     : [];

               var replicationGroupInfos =
                     spbmReplicationGroupInfoService.extractReplicationGroupInfos(
                           result.compatibilityResult, hostRefs, result.replicationGroupInfo);

               _.forEach(replicationGroupInfos, function(rg) {
                  var rgItem = {
                     label: spbmReplicationGroupInfoService.getReplicationGroupName(rg),
                     replicationGroupInfo: rg
                  };
                  self.replicationGroupItems.push(rgItem);
                  if (currentRgId && spbmReplicationGroupInfoService.equalReplicationGroupIds(
                        currentRgId, rg.id)) {
                     self.selectedReplicationGroupItem = rgItem;
                  }
               });

               if (!currentRgId || self.selectedReplicationGroupItem) {
                  // if there was no initial RG or it has beed re-selected
                  // no need to trigger RG update.
                  triggerRgUpdate = false;
               }
            }

            if (triggerRgUpdate) {
               self.onReplicationGroupSelectionChange();
            }

            validateReplicationGroupSelection();
         });
      };

      self.onReplicationGroupSelectionChange = function() {
         self.updateProfile(self.virtualDiskSettingsForm.storageProfile.selection);
         validateReplicationGroupSelection();
         self.virtualMachineDevices.notifyRgValidationCallbacks();
      };

      self.onDatastoreSelectionChange = function(newSelection, oldSelection) {
         if (newSelection.name === browseDialogOption.name) {
            if (self.getStorageForDisk) {
               selectedStorage = self.getStorageForDisk({ diskKey: device.key });
            }

            //set the storageObject.storageRef if it is missing, so we can keep the selection
            //in the location browser window, even when going back and forward
            //through the wizard's pages
            if ((!oldSelection.storageObject || !oldSelection.storageObject.storageRef)
                  && oldSelection.id) {

               oldSelection.storageObject = oldSelection.storageObject ?
                     oldSelection.storageObject : {};

               oldSelection.storageObject.storageRef =
                     defaultUriSchemeUtil.getManagedObjectReference(oldSelection.id);
            }

            getStorageLocatorItemsForCreateOrEditMode().then(function (result) {
               var selectedProfile = self.virtualDiskSettingsForm.storageProfile
                     ? self.virtualDiskSettingsForm.storageProfile.selection
                     : undefined;
               vmDatastoreLocationBrowserService.choose($scope, {
                  storageProfilesData: {
                     storageProfiles: self.storageProfiles,
                     selectedProfile: selectedProfile
                  },
                  storageData: {
                     storageLocatorItemsData: result,
                     selectedStorageItem: oldSelection.storageObject
                  },
                  disableSdrs: !self.showStoragePods
               }).then(
                     function (selectionsFromBrowserService) {
                        if (!self.virtualDiskSettingsForm.storageProfile) {
                           self.virtualDiskSettingsForm.storageProfile = {};
                        }

                        self.virtualDiskSettingsForm.storageProfile.selection =
                              selectionsFromBrowserService.selectedStorageProfile;
                        self.updateProfile(
                              selectionsFromBrowserService.selectedStorageProfile);
                        self.datastores = buildStorageSelectConfig(
                              selectionsFromBrowserService.selectedStorageItem);
                        checkDiskLocationPrivilege(self.datastores.selection.id);
                        setCapacityAndErrorMessage(
                              self.datastores.selection, self.datastores.selection.id);

                        updateReplicationGroupData(
                              selectionsFromBrowserService.selectedStorageProfile,
                              selectionsFromBrowserService.selectedStorageItem.storageObject.storageRef);

                        self.virtualDiskSettingsForm.diskProvisioningOptions =
                              virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                                    self.datastores.selection.storageObject.type,
                                    self.datastores.selection.storageObject.vStorageSupport);
                        self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                              self.virtualDiskSettingsForm.diskProvisioningOptions[0];
                     }, function () {
                        self.datastores.selection = oldSelection;
                     });
            });
         } else if (newSelection.name === storeWithVmOption.name) {
            setDiskLocationValidity(true);
            setCapacityAndErrorMessage(null);
            updateReplicationGroupData();
            self.virtualDiskSettingsForm.diskProvisioningOptions =
                  virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                        datastoreInfo?datastoreInfo.datastore.type:"",
                        datastoreInfo?datastoreInfo.vStorageSupport:"");
            self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0];
         } else {
            checkDiskLocationPrivilege(newSelection.id);
            setCapacityAndErrorMessage(newSelection, newSelection.id);

            updateReplicationGroupData(null, self.datastores.selection.storageObject.storageRef);

            self.virtualDiskSettingsForm.diskProvisioningOptions =
                  virtualDiskSettingsFormService.buildDiskProvisioningTypes(
                        self.datastores.selection.storageObject.type,
                        self.datastores.selection.storageObject.vStorageSupport);
            self.virtualDiskSettingsForm.selectedDiskProvisioningOption =
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0];
         }
      };

      self.expandedChanged = function(expanded) {
         if (self.expanded === expanded) {
            return;
         }
         self.expanded = expanded;

         if (self.inflatedDevice.isNew()) {
            setDiskLocationValidity(!self.diskLocationErrorConfig.isVisible);
            self.setDiskProfileValidity(!self.diskProfileErrorConfig.isVisible,
               self.diskProfileErrorConfig.message);
         } else if (self.expanded && self.isGroupingHardDisks) {
            //broadcast to all the other hard disks
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, {
               deviceKey: self.inflatedDevice.getKey()
            });
         }
      };

      $rootScope.$on(vmHardwareVirtualDiskService.DISK_STACK_EXPANDED, function(event, key) {
         if (self.inflatedDevice.getKey() === key.deviceKey) {
            //nothing to do, just return
            return;
         }
         self.expanded = false;
      });

      $q.all(getAllBackendStorageCallPromises()).then(function (results) {
         self.storageProfiles = results.storageProfilesPromiseResult;

         self.vmAssignmentsProperties = results.vmAssignmentsPromiseResult || {};

         if (!(self.createMode || self.cloneMode)
               && self.vmAssignmentsProperties
               && self.vmAssignmentsProperties.vmStorageProfileAssignments && self.storageProfiles) {

            var currentDevice = self.inflatedDevice.getCurrentDeviceSpec().device;
            var replicationGroup = null;
            if (currentDevice && currentDevice.key) {
               _.forEach(results.vmAssignmentsPromiseResult.vmReplicationGroupAssignments,
                     function (rgAssignment) {
                        if (rgAssignment && rgAssignment.vmObjectId) {
                           var vmObjectIdSegments = rgAssignment.vmObjectId.split(":");
                           if (vmObjectIdSegments.length > 1 &&
                                 vmObjectIdSegments[1] === currentDevice.key.toString()) {
                              replicationGroup = rgAssignment.replicationGroup;
                           }
                        }
                     });
            }

            var profile = storageProfileService.makeProfileFromDevice(
                  currentDevice,
                  self.storageProfiles,
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  replicationGroup,
                  self.inflatedDevice.isNew());

            self.inflatedDevice.setOriginalProfile(profile, replicationGroup);
         }

         if (self.inflatedDevice.isNew()) {
            self.virtualDiskSettingsForm = virtualDiskSettingsFormService.build(
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  self.createMode || self.cloneMode,
                  self.vmConfigContext,
                  self.inflatedDevice,
                  self.vmStorageId,
                  self.selectedStorageProfile,
                  self.storageProfiles,
                  self.virtualMachineDevices
            );
            // if there is already selected disk provisioning type - use it, otherwise default
            // to the first option
            var diskProvisioningType = self.virtualDiskSettingsForm.selectedDiskProvisioningOption ?
                  self.virtualDiskSettingsForm.selectedDiskProvisioningOption.type :
                  self.virtualDiskSettingsForm.diskProvisioningOptions[0].type;
            self.updateDiskProvisioningType(diskProvisioningType);

            if (self.virtualDiskSettingsForm.storageProfile
                  && self.virtualDiskSettingsForm.storageProfile.selection) {
               self.updateProfile(
                  self.virtualDiskSettingsForm.storageProfile.selection,
                  self.inflatedDevice.getCurrentReplicationGroup());
            }

            var lastPrivCheckedStorageId = {
               id: null,
               hasPrivilege: true
            };
            storeWithVmOption = { name: self.i18n('VmUi', 'DiskPage.StoreWithVM') };
            browseDialogOption = { name: self.i18n('VmUi', 'DiskPage.Browse') };
            buildStorageSelectConfig = function(selectedStorage) {
               if (selectedStorage) {
                  var selectedStorageOption = {
                     name: selectedStorage.name,
                     id: selectedStorage.id,
                     storageObject: selectedStorage.storageObject
                  };
                  return {
                     options: [storeWithVmOption, selectedStorageOption, browseDialogOption],
                     selection: selectedStorageOption
                  };
               } else {
                  return {
                     options: [storeWithVmOption, browseDialogOption],
                     selection: storeWithVmOption
                  };
               }
            };

            checkDiskLocationPrivilege = function(storageId) {
               var storageType = defaultUriSchemeUtil.getEntityType(storageId);
               //if storage pod, do not check privileges
               if (storageType === managedEntityConstants.STORAGE_POD) {
                  setDiskLocationValidity(true);
                  return;
               }
               //if we go back to the already selected storage
               //do not check for privileges second time, but
               //invalidate the form if needed (for errors to appear)
               if (lastPrivCheckedStorageId.id === storageId) {
                  setDiskLocationValidity(lastPrivCheckedStorageId.hasPrivilege);
                  return;
               }

               lastPrivCheckedStorageId.id = storageId;
               var priv = ['Datastore.AllocateSpace'];
               var promise = authorizationService.checkPrivileges(storageId, priv);
               return promise.then(function(privilegeStatuses) {
                  var hasPriv = privilegeStatuses[0];
                  lastPrivCheckedStorageId.hasPrivilege = hasPriv;
                  setDiskLocationValidity(hasPriv);
               });
            };

            setDiskLocationValidity = function(isValid) {
               self.diskLocationErrorConfig.isVisible = !isValid;
               $timeout(function() {
                  var form = self[formId];
                  if (form) {
                     var diskLocationElem = form['disk-location'];
                     if (diskLocationElem) {
                        diskLocationElem.$invalid = !isValid;
                     }
                     self[formId].$setValidity('diskLocation', isValid);
                  }
               }, 50);
            };

            selectedStorage = null;
            if (self.getStorageForDisk) {
               var selectedStorageForDisk = self.getStorageForDisk(
                     { diskKey: device.key });
               if (selectedStorageForDisk) {
                  selectedStorage = {
                     key: selectedStorageForDisk.dsKey,
                     id: selectedStorageForDisk.dsId,
                     name: selectedStorageForDisk.dsName,
                     storageObject: selectedStorageForDisk.dsObject
                  };
               }
            }
            self.datastores = buildStorageSelectConfig(selectedStorage);
         } else {
            self.virtualDiskSettingsForm = virtualDiskSettingsFormService.build(
                  self.vmAssignmentsProperties.vmStorageProfileAssignments,
                  self.createMode || self.cloneMode,
                  self.vmConfigContext,
                  self.inflatedDevice,
                  self.vmStorageId,
                  null,
                  self.storageProfiles,
                  self.virtualMachineDevices);
         }

         applyPmemPostProcessingToDisk();

         postInit();
      });

      self.revertRemoval = function() {
         self.inflatedDevice.revertRemoval();
         self.virtualMachineDevices.notifyRgValidationCallbacks();
      };

      $scope.$on('deviceAdded', function(event, device) {
         if (isAddedDeviceAController(device.deviceType)) {
            rebuildControllersDropdown();
         }
      });
      $scope.$on('deviceRemoved', function(event, device) {
         if (self.inflatedDevice.isOfType("VirtualDisk")) {
            $rootScope.$broadcast(vmHardwareVirtualDiskService.DISKS_UPDATED);
         }

         if (isAddedDeviceAController(device.deviceType)) {
            rebuildControllersDropdown();
         }
         validateReplicationGroupSelection();
      });

      self.isDiskEditable = determineDiskEditability();
      self.isRDMDisk = determineIfRdmDisk();

      self.isEditDiskModeDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditDiskModeDisabled(
               self.inflatedDevice, self.createMode, self.vmConfigContext);
      };

      self.isEditFlashReadCacheDisabled = function() {
         return self.isPmemDisk || vmHardwareVirtualDiskService.isEditFlashReadCacheDisabled(
               self.vmConfigContext.privileges, self.createMode);
      };

      self.isEditSharesDisabled = function() {
        return self.isPmemDisk || vmHardwareVirtualDiskService.isEditSharesDisabled(
              self.vmConfigContext.privileges,
              self.createMode,
              self.vmConfigContext.environment.configOption.capabilities.diskSharesSupported);
      };

      self.isDiskSharingDisabled = function() {
         return self.isPmemDisk || (self.isPoweredOn && !self.inflatedDevice.isNew());
      };

      self.customValidators = [
         {
            name: 'non-zero',
            validate: function(value) {
               return value !== 0;
            },
            message: self.i18n('VmUi', 'DiskConfig.ErrorCapacityZero')
         }
      ];

      self.hasPrivilegesToEdit = function() {
         return vmHardwareVirtualDiskService.hasPrivilegesToEditCapacity(self.vmConfigContext.privileges, self.createMode) ;
      };

      self.updateDiskFileOperation = function() {
         if (self.deleteFilesFromDisk) {
            self.inflatedDevice.setDiskFileOperation(DELETE_FILE_FROM_DISK_OPERATION);
         } else {
            self.inflatedDevice.setDiskFileOperation(undefined);
         }
      };

      self.updateFlashCacheReservation = function(flashCacheReservation) {
         self.inflatedDevice.updateFlashCacheReservation(flashCacheReservation);
      };

      self.hasError = function() {
           if(!_.isEmpty(self[self.formId])){
               return self[self.formId].$invalid;
           }
           return false;
      };

      self.shouldDisplayShares = function(expanded){
           if(!_.isEmpty(self[self.formId])){
               var errors = self[self.formId].$error;
               if(!_.isEmpty(errors)){
                  for(var obj in errors){
                     if(errors[obj].length >1 && (errors[obj][1].$name).startsWith('DiskSharesValue')){
                        return true;
                     }

                  }
               }
           }
           return expanded;
       };

       self.shouldDisplayIOPS = function(expanded){
           if(!_.isEmpty(self[self.formId])){
               var errors = self[self.formId].$error;
               if(!_.isEmpty(errors)){
                   for(var obj in errors){
                       if(errors[obj].length >1 && (errors[obj][1].$name).startsWith('IopsLimitValue')){
                           return true;
                       }

                   }
               }
           }
           return expanded;
       };

       buildIopsLimitDetails();

      self.showVmStoragePolicy = function(expanded) {
         expanded = expanded || false;
         return expanded && (!self.cloneMode || self.inflatedDevice.isNew());
      };

      self.showReplicationGroup = function(expanded) {
         expanded = expanded || false;
         return expanded && self.replicationGroupItems.length &&
               (!self.cloneMode || self.inflatedDevice.isNew());
      };

      self.areStorageProfilesReadOnly = function() {
         return !self.virtualDiskSettingsForm
            || !self.virtualDiskSettingsForm.storageProfile
               || !self.virtualDiskSettingsForm.storageProfile.options
               || self.virtualDiskSettingsForm.storageProfile.options.length === 0
               || self.isExistingPmemDisk;
      };

      self.shouldDisableDiskEdit = function() {
         return !self.isDiskEditable ||
               self.inflatedDevice.isCreatedFromExistingDisk() ||
               !self.hasPrivilegesToEdit();
      };


      self.getSelectedVirtualNodeText = function() {
         if (self.virtualDiskSettingsForm && self.virtualDiskSettingsForm.controllers) {
            var rawController = self.virtualDiskSettingsForm.controllers.selection.getCurrentDevice();

            return vmDeviceInfoService.getControllerAndNodeLabelText(
               rawController._type, rawController.busNumber, self.inflatedDevice.getCurrentDevice().unitNumber);
         }
         return '';
      };

      /* ------------------------ private ------------------------ */

      function isExistingDiskAddition() {
            return self.inflatedDevice.isNew() && self.inflatedDevice.isCreatedFromExistingDisk();
      }

      function determineDiskEditability() {
         if (determineIfRdmDisk()) {
            //if RDM disk, always return false
            return false;
         }

         if (self.createMode) {
            return true;
         } else if (self.isPmemDisk && self.isPoweredOn) {
            return false;
         } else {
            return self.inflatedDevice.getCurrentDevice().backing.parent ? false : true;
         }
      }

      function determineIfRdmDisk() {
         return self.inflatedDevice.getCurrentDevice().backing._type ===
               diskBackingInfoConstants.RAWDISKMAPPING;
      }

      function buildIopsLimitDetails() {
         var MIN = 16;
         var MAX = (Math.pow(2, 31) - 1);
         self.iopsLimitDetails = {};

         self.iopsLimitDetails.min = MIN;
         self.iopsLimitDetails.max = MAX;
         self.iopsLimitDetails.iopsRecommendations = [
            {
               name: self.i18n('VmUi', 'VmCpu.Limit.Minimum'),
               value: MIN
            },
            {
               name: self.i18n('VmUi', 'VmCpu.Limit.Maximum'),
               value: MAX
            }
         ];
         self.iopsLimitDetails.iopsLimitSelectList = [
            {
               label: self.i18n('VmUi', 'DiskConfig.Unlimited'),
               data: 'unlimited'
            },
            {
               label: self.i18n('VmUi', 'sharesInfoLevel.custom'),
               data: 'custom'
            }
         ];

         self.iopsLimitDetails.errorMessage = {
            max: function() {
               return self.i18n('Common', 'SharesControl.RangeError', MIN, MAX);
            },
            min: function() {
               return self.i18n('Common', 'SharesControl.RangeError', MIN, MAX);
            }
         };

         self.iopsLimitDetails.selectChange = function() {
            if (self.iopsLimitDetails.iopsLimitSelection.data === 'unlimited') {
               self.virtualDiskSettingsForm.ioLimit = VirtualDisk.UNLIMITED_DISK;
            } else {
               self.virtualDiskSettingsForm.ioLimit = MIN;
            }
            self.inflatedDevice.updateStorageIOAllocation(self.virtualDiskSettingsForm.ioLimit);
         };
      }

      function applyPmemPostProcessingToDisk() {
         // Use the applyPmemProfile function in create mode to set Pmem Storage Policy
         // when Pmem Baseline is selected.
         if (self.createMode && applyPmemProfileToDisk()) {
            return;
         }

         if (self.cloneMode) {
            var advancedConfiguration =
                  self.getAdvancedConfigurationForDisk(self.inflatedDevice);
            if (advancedConfiguration) {
               self.updateProfile(advancedConfiguration.storageProfile,
                     advancedConfiguration.replicationGroup);
               return;
            }
            if (applyPmemProfileToDisk()) {
               return;
            }
            if (!self.inflatedDevice.isStorageProfileManuallySet()) {
               var diskProfile = self.selectedStorageProfile;
               if (!self.inflatedDevice.isNew() && self.keepExistingProfileAssignments) {
                  diskProfile = storageProfileService.getDefaultProfile();

                  var diskAssignment = storageProfileService.findDiskAssignment(
                        self.vmAssignmentsProperties.vmStorageProfileAssignments,
                        self.inflatedDevice.getCurrentDevice());
                  if (diskAssignment) {
                     diskProfile = {
                        id: diskAssignment.profile.profileId.uniqueId,
                        label: diskAssignment.profile.name
                     };
                  }
               }

               self.updateProfile(diskProfile,
                     self.inflatedDevice.getCurrentReplicationGroup());
               self.virtualDiskSettingsForm.storageProfile.selection = diskProfile;
            }
         }
      }

      function findPmemProfile(storageProfiles) {
         return _.find(storageProfiles, function(storageProfile) {
            return storageProfileService.isPmemStorageProfile(storageProfile);
         });
      }

      function applyPmemProfileToDisk() {
         if (virtualDiskPmemService.shouldApplyPmemProfileToDisk(
               self.inflatedDevice, self.storageBaselineId)) {
            // In hybrid mode the pmem disks need to have their profile set to the Pmem
            // profile in order to show up correctly on the RTC page.
            // The RTC page gets its data about disks from virtualMachineDevices, which
            // is directly populated by this component (for disks at least)
            var pmemStorageProfile = findPmemProfile(self.storageProfiles);
            self.updateProfile(pmemStorageProfile);
            self.virtualDiskSettingsForm.storageProfile.selection = pmemStorageProfile;
            return true;
         }
         return false;
      }

      function postInit() {
         setErrorMessage(self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage);

         self.iopsLimitDetails.iopsLimitSelection =
               (self.virtualDiskSettingsForm.ioLimit === VirtualDisk.UNLIMITED_DISK) ?
                     self.iopsLimitDetails.iopsLimitSelectList[0] :
                     self.iopsLimitDetails.iopsLimitSelectList[1];

         if (!self.createMode) {
            self.errorMessages.min =
                  self.i18n('VmUi', 'DiskConfig.ErrorCapacityShrink');
         }

         updateReplicationGroupData();
      }

      function setErrorMessage(maxErrorMessage) {
         self.errorMessages = {
            max: maxErrorMessage
         };
      }

      function setCapacityAndErrorMessage(selectedStorageInfo, datastoreId) {
         var datastoreInfo = datastoreService.findDatastore(
               datastoreId || self.vmStorageId,
               self.vmConfigContext.environment.configTarget);

         if (selectedStorageInfo && !isStoragePod(selectedStorageInfo)) {
            self.virtualDiskSettingsForm.diskFile = '[' + selectedStorageInfo.name + ']';
         }
         else {
            self.virtualDiskSettingsForm.diskFile = '';
         }

         var capacity = virtualDiskSettingsFormService.buildCapacity(
               self.inflatedDevice,
               self.createMode || self.cloneMode,
               datastoreInfo);
         self.virtualDiskSettingsForm.capacity.minInMB = capacity.minInMB;
         self.virtualDiskSettingsForm.capacity.maxInMB = capacity.maxInMB;
         self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage =
               capacity.maxExceededErrorMessage;
         self.virtualDiskSettingsForm.capacity.isMaxAvailable =
               capacity.isMaxAvailable;
         setErrorMessage(self.virtualDiskSettingsForm.capacity.maxExceededErrorMessage);

         self.setStorageForDisk({ storageInfo: selectedStorageInfo, device: device });

         self.inflatedDevice.updateFileName(self.virtualDiskSettingsForm.diskFile);

         if (selectedStorageInfo && selectedStorageInfo.storageObject) {
            self.inflatedDevice.updateDatastoreMor(selectedStorageInfo.storageObject.storageRef);
            if (selectedStorageInfo.storageObject.parentStoragePod) {
               self.inflatedDevice.updateParentStoragePodMor(
                     selectedStorageInfo.storageObject.parentStoragePod);
            }
         } else {
            self.inflatedDevice.updateDatastoreMor(null);
         }
      }

      function isStoragePod(selectedStorageInfo) {
         return selectedStorageInfo &&
               selectedStorageInfo.storageObject &&
               selectedStorageInfo.storageObject.storageRef &&
               selectedStorageInfo.storageObject.storageRef.type === managedEntityConstants.STORAGE_POD;
      }

      function isAddedDeviceAController(deviceType) {
         var isScsiController = deviceType === deviceTypeConstants.SCSICONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.SCSICONTROLLER);
         var isSataController = deviceType === deviceTypeConstants.VIRTUAL_SATA_CONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.VIRTUAL_SATA_CONTROLLER);
         var isNvmeController = deviceType === deviceTypeConstants.NVME_CONTROLLER ||
               deviceClassLineageService.isClassNameSubclassOf(deviceType, deviceTypeConstants.NVME_CONTROLLER);
         return isScsiController || isSataController || isNvmeController;
      }

      function rebuildControllersDropdown() {
         self.virtualDiskSettingsForm.controllers =
               virtualDiskSettingsFormService.buildControllersDropdown(
                     self.inflatedDevice,
                     self.virtualMachineDevices.getAllDevicesNotMarkedForRemoval()
                     );
      }

      function getStorageLocatorItemsForCreateOrEditMode() {
         if (self.storageLocatorItemsData) {
            return $q.when(self.storageLocatorItemsData);
         } else {
            return vmDatastoreLocationBrowserService.getStorageLocatorItems(self.vmId);
         }
      }

      function getAllBackendStorageCallPromises () {

         if (self.createMode || self.cloneMode || !self.vmAssignmentsProperties) {
            return {
               storageProfilesPromiseResult: self.storageProfiles,
               vmAssignmentsPromiseResult: self.vmAssignmentsProperties
            };
         }

         return vmHardwareVirtualDiskService.getAllBackendStorageCallPromises
         ($q, self.vmAssignmentsProperties, self.storageProfiles);

      }

      function init_aria() {
         var i18n = function(key) {
            return i18nService.getString("VmUi", 'DiskPage.' + key);
         };

         self.ARIA_LBL_CAPACITY = self.i18n("VmUi", "VmDiskView.capacity");
         self.ARIA_LBL_PROFILE = i18n('Profile');
         self.ARIA_LBL_LOCATION = i18n('Location');
         self.ARIA_LBL_RGROUP = i18n('ProtectionGroup');
         self.ARIA_LBL_PROVISION = i18n('DiskProvisioning');
         self.ARIA_LBL_LIMIT_IOPS = i18n('LimitIOPs');
         self.ARIA_LBL_CACHE = i18n('CacheReservation');
         self.ARIA_LBL_SHARING = i18n('Sharing');
         self.ARIA_LBL_SHARES = i18n('Shares');
         self.ARIA_LBL_DISK_MODE = i18n('DiskMode');

         i18n = function(key) {
            return i18nService.getString("VmUi", 'DeviceDeletedControl.' + key);
         };
         self.ARIA_LBL_REMOVE = i18n('DeviceDeleted');
         self.ARIA_LBL_DESTROY = i18n('DeleteFiles');
         self.ARIA_LBL_RESTORE = i18n('Restore');
      }

      init_aria();
   }
}());
